// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { toast } from 'sonner';
import { axios } from './axios';

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const useScoresheetStore = create(
  immer((set) => ({
    // Games needing results for the org (powers the Upcoming Games page).
    unscoredGames: [],

    getUnscoredByOrganization: async (orgId, cb) => {
      try {
        const { data } = await axios.get(`${baseUrl}/games/organization/${orgId}/unscored`);
        set((state) => {
          state.unscoredGames = data.result || [];
        });
        cb && cb(data.result || []);
      } catch (error) {
        console.error('Error in getUnscoredByOrganization:', error);
      }
    },

    // Upload one scoresheet photo → public Spaces URL.
    uploadScoresheet: async (file, orgId, token) => {
      const form = new FormData();
      form.append('upload', file);
      // Let axios set the multipart boundary (see adminStore.postLeagueBanner note).
      const { data } = await axios.post(
        `${baseUrl}/scoresheets/${orgId}/upload`,
        form,
        createAuthHeader(token),
      );
      const url = data?.result?.url;
      if (!url) throw new Error(data?.error || 'Upload failed');
      return url;
    },

    // Enqueue an AI parse job → { jobId, queue }.
    parseScoresheet: async (input, token) => {
      const { data } = await axios.post(
        `${baseUrl}/scoresheets/parse`,
        input,
        createAuthHeader(token),
      );
      return data;
    },

    // Poll /jobs/:jobId until the parse completes; resolves with the structured
    // result or throws. Mirrors the BannerEditor polling loop (1.5s cadence).
    pollScoresheetJob: async (jobId, token, opts = {}) => {
      const { intervalMs = 1500, timeoutMs = 120000, onState } = opts;
      const start = Date.now();
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { data } = await axios.get(
          `${baseUrl}/jobs/${jobId}?queue=scoresheets`,
          createAuthHeader(token),
        );
        const status = data?.result || data;
        if (onState) onState(status.state);
        if (status.state === 'completed') return status.result;
        if (status.state === 'failed') throw new Error(status.error || 'Scoresheet parse failed');
        if (Date.now() - start > timeoutMs) throw new Error('Scoresheet parse timed out');
        await sleep(intervalMs);
      }
    },

    // Create a single new player (from an admin-added scoresheet row).
    createPlayer: async (player, token) => {
      const { data } = await axios.post(`${baseUrl}/players/d`, player, createAuthHeader(token));
      if (data?.error) {
        toast.error(data.error);
        return null;
      }
      return data.result;
    },
  })),
);

export default useScoresheetStore;
